import React from 'react'
import { useState } from 'react'
import './tooltip.scss'

const Tooltip = ({children, text}) => {
  const [isVisible, setIsVisible] = useState(false)
  return (
    <div
      className='tooltip-container'
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      {isVisible && <div className='tooltip-content'>{text}</div>}
    </div>
  )
}

export default Tooltip
